/**
 * Leave the SPA for `path` with a full page load.
 *
 * A module of its own for one reason: tests mock it. jsdom does not implement
 * navigation, and a spec that reaches `window.location.assign` either logs
 * "not implemented" or, worse, passes without anyone noticing nothing happened.
 *
 * Used where an in-app `router.push` is not enough because in-memory state has
 * to go — a tenant switch leaves every tenant-scoped Pinia store holding the
 * previous customer's data, and a reload drops them all without a hand-kept
 * reset list that rots as stores are added.
 */
export function hardNavigate(path: string): void {
  window.location.assign(path)
}
